import { apiClient } from './api'

export interface TemplateFormField {
  name: string
  label: string
  type: 'text' | 'number' | 'select' | 'multiselect'
  required: boolean
  options?: string[]
  placeholder?: string
  description?: string
}

export interface ProjectFormField {
  name: string
  label: string
  type: 'text' | 'number' | 'select' | 'multiselect' | 'textarea' | 'date' | 'time' | 'range'
  required: boolean
  options?: string[]
  placeholder?: string
  description?: string
  min?: number
  max?: number
  step?: number
  unit?: string
  section?: string
}

export interface ProjectFormConfig {
  projectFields: ProjectFormField[]
}

export interface TemplateFormConfig {
  categories: Array<{
    id: string
    name: string
    description: string
    sortOrder: number
  }>
  unitTypes: Array<{
    id: string
    name: string
    abbreviation: string
    category: string
    sortOrder: number
  }>
  specifications: {
    fields: TemplateFormField[]
  }
  industryStandards: {
    colors?: string[]
    brands?: string[]
    styles?: string[]
    purities?: Array<{ id: string; name: string; value: string }>
    grades?: string[]
    finishes?: string[]
  }
}

export const templateApi = {
  // Get form configuration for user's current template
  async getUserFormConfig(): Promise<TemplateFormConfig> {
    return apiClient.get('/templates/user/form-config')
  },

  // Get form configuration for a specific template
  async getTemplateFormConfig(templateId: string): Promise<TemplateFormConfig> {
    return apiClient.get(`/templates/${templateId}/form-config`)
  },

  // Get project form configuration for user's current template
  async getUserProjectFormConfig(): Promise<ProjectFormConfig> {
    return apiClient.get('/templates/user/project-form-config')
  },

  // Get project form configuration for a specific template
  async getTemplateProjectFormConfig(templateId: string): Promise<ProjectFormConfig> {
    return apiClient.get(`/templates/${templateId}/project-form-config`)
  },

  // Get user's current template
  async getUserCurrentTemplate() {
    return apiClient.get('/templates/user/default')
  },

  // Get user's templates with custom business names
  async getUserTemplates() {
    return apiClient.get('/templates/user')
  },

  // Update custom business name for a template
  async updateCustomBusinessName(templateId: string, customBusinessName: string | null) {
    return apiClient.patch(`/templates/user/${templateId}/custom-business-name`, {
      customBusinessName
    })
  }
}